import { createFileRoute } from '@tanstack/react-router';

import { ActionPermissionsPage } from '@/areas/settings/Settings/ActionPermissionsPage/ActionPermissionsPage';
import { canViewAdvancedUserManagement } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/settings/_menu/organization/user-management/action-permissions',
)({
    staticData: {
        access: { permissions: canViewAdvancedUserManagement },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ActionPermissionsPage />;
}
